'use strict';

module.exports = [
  'LocalFileDataServiceImpl',
  function (LocalFileDataServiceImpl) {
    /**
     * Methods:
     *
     *
     */
    return LocalFileDataServiceImpl;
  }];


// WEBPACK FOOTER //
// ./src/js/core-utilities/upload-service/LocalFileDataService.js